import React, { forwardRef, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { Field, useFormikContext } from 'formik';
import { PaymentFormValues } from '@entities/payment';
import { getSteamAccountFinalAmount } from '@entities/price';
import { steamLoginAddGtm } from '@shared/lib/gtm/redesign';
import { Desktop, Mobile } from '@shared/lib/react';
import { InputField } from '@shared/ui/organisms';
import { Amount } from '@root/api/ump-ewallet';
import WhereToFindSteamLoginButton, { SteamLoginModalProps } from './WhereToFindSteamLoginButton';
interface SteamLoginFieldProps {
  getCommissions: (amount: Required<Pick<Amount, 'base' | 'fee' | 'total'>>) => void;
  renderSteamLoginModal: (props: SteamLoginModalProps) => ReactNode;
}
const SteamLoginField = forwardRef<HTMLInputElement, SteamLoginFieldProps>(({
  getCommissions,
  renderSteamLoginModal
}, ref) => {
  const {
    values,
    validateForm,
    setFieldValue,
    handleBlur
  } = useFormikContext<PaymentFormValues>();
  const handleLoginFieldBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    const validationErrors = await validateForm();
    if (!validationErrors.login && !validationErrors.price) {
      getCommissions(getSteamAccountFinalAmount(Number(values.price)));
    }
    if (!validationErrors?.login && values.login?.trim()) {
      steamLoginAddGtm();
    }
    handleBlur(e);
  };
  return <FieldWrapper ref={ref}>
        <Field isClearable size={{
      mobile: '64',
      desktop: '72'
    }} name="login" label="Логин Steam" autoComplete="section-steam username" button={<WhereToFindSteamLoginButton renderSteamLoginModal={renderSteamLoginModal} />} onClear={() => setFieldValue('login', '')} onBlur={handleLoginFieldBlur} component={InputField} />
      </FieldWrapper>;
});
export default SteamLoginField;
const FieldWrapper = /*#__PURE__*/styled('div')({
  name: "FieldWrapper",
  class: "f1mc9oyf",
  propsAsIs: false
});

require("./SteamLoginField.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamLoginField.tsx");